import classnames from 'classnames';
import { useState } from 'react';
import { SectionSubtitle, SectionTitle } from '@/sem/styles';
import { Clickable } from 'packages/components/src';
import { useDeviceType } from '~/context/common/DeviceContext';
import type { SemInventoryModuleSectionContent } from '~/contracts/sem';
import DownArrowIcon from '~/icons/DownArrow';
import { GridWrapper, HeadingWrapper, Wrapper } from './GridSection.styles';
import VehicleTile from '../VehicleTile';

const GridSection = ({
  id,
  title: sectionTitle,
  subtitle,
  viewAllLink,
  viewAllLinkText,
  inventory = []
}: SemInventoryModuleSectionContent) => {
  const { isDesktop } = useDeviceType();
  const [isExpanded, setIsExpanded] = useState(false);

  if (!id) return null;

  const vehiclesToShow = isDesktop ? 8 : 4;

  const inventoryToDisplay = isExpanded
    ? inventory
    : inventory?.slice(0, vehiclesToShow);

  return (
    <Wrapper>
      <HeadingWrapper>
        <SectionTitle>{sectionTitle}</SectionTitle>
        <SectionSubtitle>{subtitle}</SectionSubtitle>
        {viewAllLink ? (
          <a
            className="!no-underline tl-link-m"
            href={viewAllLink}
            data-analytics-id="Inventory - View More Results"
            data-analytics-attributes={JSON.stringify({
              title: viewAllLinkText,
              linkUrl: viewAllLink
            })}
          >
            {viewAllLinkText}
          </a>
        ) : null}
      </HeadingWrapper>
      <GridWrapper>
        {inventoryToDisplay?.map(vehicle => {
          return vehicle?.linkUrl ? (
            <a
              href={vehicle.linkUrl}
              key={vehicle.title}
              className="inline-block !w-fit no-underline"
              data-analytics-id="Inventory - Vehicle Tile"
              data-analytics-attributes={JSON.stringify({
                title: vehicle.title,
                linkUrl: vehicle.linkUrl
              })}
            >
              <VehicleTile {...vehicle} />
            </a>
          ) : null;
        })}
      </GridWrapper>
      {inventory && vehiclesToShow < inventory?.length && (
        <Clickable
          data-analytics-id="Inventory - See More/Less"
          data-analytics-attributes={JSON.stringify({
            isExpanded
          })}
          onClick={() => setIsExpanded(!isExpanded)}
          className="flex items-center text-blue-2 tl-body-m m:self-center"
        >
          {isExpanded ? 'Show Less' : 'Show More'}
          <DownArrowIcon
            className={classnames('ml-8', {
              'rotate-180': isExpanded
            })}
          />
        </Clickable>
      )}
    </Wrapper>
  );
};

export default GridSection;
